import axios, { AxiosInstance } from 'axios';

export const getArquivoStorageService = (
  baseResourcePath: string,
  axiosInstance?: AxiosInstance
) => {
  const {
    TransProgressKind,
    useTransProgress
  }: typeof import('common/components') = require('common/components');
  const resource = `${baseResourcePath}/arquivos-storage`;

  const axiosFinal: AxiosInstance = axiosInstance || axios;

  const postArquivoParametro = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    return axiosFinal.post<string>(
      `${resource}/parametro-arquivo`,
      formData,
      useTransProgress(file.name, TransProgressKind.UPLOAD, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    );
  };

  const downloadArquivoParametro = (parametro: number) => {
    return axiosFinal
      .get(`${resource}/parametro-arquivo/${parametro}`, {
        responseType: 'arraybuffer',
        ...useTransProgress(
          `parametro-${parametro}`,
          TransProgressKind.DOWNLOAD
        )
      })
      .then(response => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const filename = response.headers['content-disposition']
          ? response.headers['content-disposition']
              .split('filename=')[1]
              .replace(/"/g, '')
          : `arquivo-parametro-${parametro}`;
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        link.remove();
      });
  };

  return {
    postArquivoParametro,
    downloadArquivoParametro
  };
};
